<template>
<div>

<p>
  Your organization, {{$rc.$state.getOrganizationLabel()}}, is preparing to launch RedChirp soon. Please complete these quick steps to make sure your User Account is ready for the upcoming launch:
</p>

<div
  style="padding-left: 2em"
>
  <p><u><b>
    Bookmark RedChirp on your computer
  </b></u></p>

  <p>
        Bookmark this page! This will allow you to quickly return to RedChirp without having to sign in every time.
  </p>
</div>

<div
  style="padding-left: 2em"
>
  <p><u><b>
    Add the RedChirp App to your phone
  </b></u></p>

  <p>
    RedChirp is not yet available to download from the App stores, but watch these one-minute videos about how to add the RedChirp App to your <a href="https://vimeo.com/481839003" target="_blank">iPhone</a> or <a href="https://vimeo.com/481841786" target="_blank">Android</a> phone.
  </p>
</div>

<div
  style="padding-left: 2em"
  v-if="profile.bot_endpoint != null"
>
  <p><u><b>
    Add this contact to your personal and/or work cell
  </b></u></p>

  <p>
    {{$rc.pretty(profile.bot_endpoint,'endpoint')}}: Name this "RedChirp Bot". If you choose to receive text notifications, this number will text you &mdash; <b>only within the times you allow!</b> &mdash; when your attention is needed.
  </p>
</div>

<div
  style="padding-left: 2em"
  v-if="profile.bot_endpoint != null"
>
  <p><u><b>
    Need help with anything?
  </b></u></p>

  <p>
    <a 
      v-on:click="$rc.contactSupport('Welcome screen')"
    >
      Need help?  Click here to contact RedChirp support.
    </a>
  </p>
</div>

<p>
  Once you complete these steps, you're all set for now. You'll be invited to a future training via Zoom where we will help you personalize RedChirp and show you how to use it.
</p> 

<p>
    <v-switch
        label="I am ready for training"
        v-model="profile.setup_tasks.ready_for_training"
        v-on:change="onChangeReadySwitch"
    />
</p>

<m-edit-instant
  v-if="$rc.$state.isAuthActorSystemAdmin()"
  label="Training Time (Staff Only)"
  :value="profile.organization_admin_settings.time_training"
  v-on:input="onChangeTimeTraining" 
  optional
/>

</div>
</template>

<script>
import mEditInstant from '../../components/input/m-edit-instant.vue';
export default {
  components: { mEditInstant },
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    mounted () {
    },

    methods: {
        onChangeReadySwitch(value) {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/tasks/ready_for_training',
            
                'params' : {
                        'employee_id': this.profile.employee_account.employee_id,
                        'value': value,
                    },
            
                'on_success': (data) => {
                        this.$emit('update-profile',data);
                    },
            
                'on_error': 'Unable to update settings',
            });
        },

        onChangeTimeTraining(time)
        {
             this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/admin/organization-admin-settings',
            
                'params' : {
                        'organization_id': this.profile.organization_account.organization_id,
                        'time_training': time,
                    },
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to set training time',
            });
        },
    },

}
</script>

<style lang="scss" scoped>

</style>